import { Icon } from "./Icon.tsx";

/** "Results Animation" (play results over the map, time-stepped) icon — a small map pin with a play glyph. */
export function ResultsAnimationIcon() {
  return (
    <Icon>
      <path d="M12 21s7-7.58 7-12A7 7 0 0 0 5 9c0 4.42 7 12 7 12Z" />
      <path d="M10.5 6.5v5l4-2.5-4-2.5Z" fill="currentColor" stroke="none" />
    </Icon>
  );
}
